/* Current Nostalgia - UX helpers: free-shipping bar, cart stock lines, recently viewed,
   header height var, "new in your size" row, and the homepage de-duplication pass.
   v85: the cart's last-one line reads "Only 1 left."; cart messages never show stock counts.
   v90: cnPointTile points a grouped tile (one tile for several independent size listings,
   snippets/cn-grid-item) at one size: its card links, Quick View, quick-add size and price follow
   that size's own product. Used by the collection size filter, the homepage "in your size" row and
   the tile's own quick-add size menu.
   v1.3: the homepage "in your size" tiles are no longer part of the page; sections/cn-home-size
   fetches them once it knows the shopper has a size, then calls window.cnSizeRowFill. */
(function () {
  if (window.__cnUx) return;
  window.__cnUx = true;

  /* waist <-> letter equivalents, same map as the collection size filter */
  var EQ = { '28': 'xs', '30': 's', '32': 'm', '34': 'l', '36': 'xl', '38': 'xxl' };
  var EQR = {};
  Object.keys(EQ).forEach(function (k) { EQR[EQ[k]] = k; });
  function sizeHit(attr, s) {
    var hay = ' ' + attr + ' ';
    if (hay.indexOf(' ' + s + ' ') > -1) return true;
    var alt = EQ[s] || EQR[s];
    return alt ? hay.indexOf(' ' + alt + ' ') > -1 : false;
  }

  /* v90: s = a size token ('' = back to the tile's own destination) or a size chip element */
  function cnPointTile(li, s) {
    var dest = li && li.getAttribute('data-cn-dest');
    if (!dest) return;
    var chip = null;
    if (s && s.nodeType === 1) chip = s;
    else if (s) {
      Array.prototype.some.call(li.querySelectorAll('a.cn-sizes__s[data-cn-tok]'), function (a) {
        if (sizeHit(a.getAttribute('data-cn-tok'), s)) { chip = a; return true; }
        return false;
      });
    }
    var href = chip ? chip.getAttribute('href') : dest;
    if ((li.getAttribute('data-cn-at') || dest) === href && li.querySelector('a.cn-sizes__s.is-on') === chip) return;
    li.setAttribute('data-cn-at', href);
    var path = dest.split('?')[0];
    li.querySelectorAll('a[href]:not(.cn-sizes__s)').forEach(function (a) {
      if (!a.hasAttribute('data-cn-orig')) {
        if ((a.getAttribute('href') || '').split('?')[0] !== path) return;
        a.setAttribute('data-cn-orig', a.getAttribute('href'));
      }
      a.setAttribute('href', chip ? href : a.getAttribute('data-cn-orig'));
    });
    var qv = li.querySelector('[data-cn-qv]');
    if (qv) qv.setAttribute('data-cn-qv', href);
    var sel = li.querySelector('.cn-qa select[name="id"]');
    if (sel) {
      if (!sel.hasAttribute('data-cn-orig')) sel.setAttribute('data-cn-orig', sel.value);
      var want = chip && chip.getAttribute('data-cn-variant') ? chip.getAttribute('data-cn-variant') : sel.getAttribute('data-cn-orig');
      if (sel.value !== want) sel.value = want;
    }
    var price = li.querySelector('.price');
    if (price && !price.classList.contains('price--on-sale')) {
      price.querySelectorAll('.price__regular .price-item--regular').forEach(function (el) {
        if (!el.hasAttribute('data-cn-orig')) el.setAttribute('data-cn-orig', el.textContent);
        el.textContent = chip && chip.getAttribute('data-cn-price') ? chip.getAttribute('data-cn-price') : el.getAttribute('data-cn-orig');
      });
    }
    li.querySelectorAll('a.cn-sizes__s').forEach(function (a) {
      var on = a === chip;
      a.classList.toggle('is-on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  window.cnPointTile = cnPointTile;
  /* picking a size in a grouped tile's quick-add menu points the tile at that size, so the photo,
     title and Quick View open the size the shopper chose */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('.cn-qa select[name="id"]')) return;
    var li = sel.closest('li[data-cn-dest]');
    if (!li) return;
    var chip = li.querySelector('a.cn-sizes__s[data-cn-variant="' + String(sel.value).replace(/[^0-9]/g, '') + '"]');
    cnPointTile(li, chip || '');
  });

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---- Free shipping bar + processing time ----
     Free shipping is US-only, so the progress line says so rather than implying it applies
     everywhere. The note is the approved shipping line: it states the processing time and says
     plainly that transit depends on destination and service. */
  /* v94: US shoppers get an estimated delivery window instead of the general line. Orders ship
     within 2 business days and US standard transit is 3-7 business days, so the window runs from
     3 to 9 business days after today (store time, New York), skipping weekends and USPS holidays.
     It is worded as an estimate - the shipping policy says delivery dates aren't guaranteed. */
  var HOLIDAYS = ' 2026-11-11 2026-11-26 2026-12-25 2027-01-01 2027-01-18 2027-02-15 2027-05-31 2027-06-18' +
    ' 2027-07-05 2027-09-06 2027-10-11 2027-11-11 2027-11-25 2027-12-24 2027-12-31 2028-01-17 2028-02-21' +
    ' 2028-05-29 2028-06-19 2028-07-04 2028-09-04 2028-10-09 2028-11-10 2028-11-23 2028-12-25 ';
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function storeToday() {
    var now = new Date();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      if (p.year && p.month && p.day) return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    } catch (e) {}
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  }
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x.setUTCDate(x.getUTCDate() + 1);
      var w = x.getUTCDay();
      if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(' ' + x.toISOString().slice(0, 10) + ' ') < 0) n--;
    }
    return x;
  }
  function etaRange() {
    var t = storeToday(), a = addBusinessDays(t, 3), b = addBusinessDays(t, 9);
    var am = MON[a.getUTCMonth()], bm = MON[b.getUTCMonth()];
    return am === bm ? am + ' ' + a.getUTCDate() + '–' + b.getUTCDate()
      : am + ' ' + a.getUTCDate() + ' – ' + bm + ' ' + b.getUTCDate();
  }
  window.cnEtaRange = etaRange;
  function shipNote() {
    if (window.Shopify && Shopify.country === 'US') {
      return '<span class="cn-ship__eta"><svg width="16" height="12" viewBox="0 0 16 12" aria-hidden="true"><path d="M1 1.5h9v7H1zM10 4h3l2 2.5v2h-5z" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="4" cy="9.6" r="1.4" fill="#fff" stroke="currentColor" stroke-width="1.2"/><circle cx="12.4" cy="9.6" r="1.4" fill="#fff" stroke="currentColor" stroke-width="1.2"/></svg>' +
        'Estimated delivery <strong>' + etaRange() + '</strong> with US standard shipping.</span> Orders ship within 2 business days.';
    }
    return 'Orders ship within 2 business days. Delivery time varies by destination and shipping method.';
  }
  var SHIP_HTML = '<div class="cn-ship" data-cn-ship data-threshold="15000" hidden>' +
    '<p class="cn-ship__msg" data-cn-ship-msg></p>' +
    '<div class="cn-ship__track"><span class="cn-ship__fill" data-cn-ship-fill></span></div>' +
    '<p class="cn-ship__note">' + shipNote() + '</p></div>';
  function ensureShipBars() {
    var added = false;
    var head = document.querySelector('cart-drawer .drawer__header');
    if (head && !(head.nextElementSibling && head.nextElementSibling.matches('[data-cn-ship]'))) {
      head.insertAdjacentHTML('afterend', SHIP_HTML); added = true;
    }
    var blocks = document.querySelector('.cart__blocks');
    if (blocks && !(blocks.previousElementSibling && blocks.previousElementSibling.matches('[data-cn-ship]'))) {
      blocks.insertAdjacentHTML('beforebegin', SHIP_HTML); added = true;
    }
    return added;
  }

  function paintShip(cart) {
    document.querySelectorAll('[data-cn-ship]').forEach(function (el) {
      var t = parseInt(el.getAttribute('data-threshold'), 10) || 15000;
      var total = cart.total_price || 0;
      var left = t - total;
      el.hidden = !cart.item_count;
      var msg = el.querySelector('[data-cn-ship-msg]');
      var fill = el.querySelector('[data-cn-ship-fill]');
      if (msg) msg.innerHTML = left > 0
        ? "You're <strong>" + money(left) + '</strong> away from free US shipping'
        : "You've unlocked <strong>free US shipping</strong>";
      if (fill) fill.style.width = Math.min(100, Math.round((total / t) * 100)) + '%';
    });
    emptyCartHelp(cart);
  }
  function refreshShip() {
    ensureShipBars();
    capQty();
    if (!document.querySelector('[data-cn-ship]')) return;
    fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(paintShip).catch(function () {});
  }

  /* ---- Empty cart: somewhere to go ---- */
  function emptyCartHelp(cart) {
    var host = document.querySelector('cart-drawer .drawer__inner-empty, .cart__empty-text');
    if (!host) return;
    host = host.closest('.drawer__inner-empty') || host.parentElement;
    if (!host || cart.item_count) return;
    if (host.querySelector('[data-cn-empty-links]')) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var html = '<ul class="cn-empty__links" data-cn-empty-links>' +
      '<li><a href="' + root + 'collections/new">New arrivals</a></li>' +
      '<li><a href="' + root + 'collections/all">All products</a></li>' +
      '<li><a href="' + root + 'pages/brands">Shop by brand</a></li></ul>';
    host.insertAdjacentHTML('beforeend', html);
  }

  /* ---- Cart stock: cap the + button, and flag a line that is the last one ---- */
  var capSeq = 0;
  function capQty() {
    var sel = 'cart-drawer .quantity__input, cart-items .quantity__input';
    if (!document.querySelector(sel)) return;
    var seq = ++capSeq;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cn-cart-stock', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (seq !== capSeq) return;
        var m = String(d['cn-cart-stock'] || '').match(/<script[^>]*id="cn-cart-stock"[^>]*>([\s\S]*?)<\/script>/);
        var map = m ? JSON.parse(m[1]) : {};
        document.querySelectorAll(sel).forEach(function (input) {
          var q = map[input.getAttribute('data-quantity-variant-id')];
          if (typeof q !== 'number' || q < 1) return;
          input.max = q;
          var wrap = input.closest('quantity-input');
          var plus = wrap && wrap.querySelector('button[name="plus"]');
          if (plus) {
            var full = (parseInt(input.value, 10) || 0) >= q;
            plus.classList.toggle('disabled', full);
            plus.disabled = full;
          }
          var row = input.closest('.cart-item') || (wrap && wrap.parentElement);
          if (!row) return;
          var note = row.querySelector('[data-cn-only]');
          if (q === 1) {
            if (!note) {
              note = document.createElement('p');
              note.className = 'cn-only';
              note.setAttribute('data-cn-only', '');
              (wrap && wrap.parentElement ? wrap.parentElement : row).appendChild(note);
            }
            note.textContent = 'Only 1 left.';
          } else if (note) {
            note.remove();
          }
        });
      })
      .catch(function () {});
  }

  /* ---- v85: no stock counts in cart messages ----
     Stock numbers are never shown (the one exception is "Only 1 left."). Shopify's own cart
     messages name them - "You can only add 3 of this item to your cart", "All 2 ... are in your
     cart" - so those become one plain line, in the cart, the cart drawer and under Add to Bag.
     The + button still stops at what's in stock (capQty above); inventory tracking is unchanged. */
  var MAXED = "That's all we have of this item.";
  function noCount(msg) {
    if (typeof msg !== 'string') return msg;
    return /\d/.test(msg) && /(cart|bag|add|stock|available|maximum)/i.test(msg) ? MAXED : msg;
  }
  if (window.cartStrings) window.cartStrings.quantityError = MAXED;
  if (window.quickOrderListStrings) window.quickOrderListStrings.max_error = MAXED;
  function patchMsg(tag, method, argIndex) {
    if (!window.customElements) return;
    customElements.whenDefined(tag).then(function () {
      var C = customElements.get(tag), p = C && C.prototype;
      if (!p || typeof p[method] !== 'function' || p[method].__cnNoCount) return;
      var orig = p[method];
      var wrapped = function () {
        var a = Array.prototype.slice.call(arguments);
        a[argIndex] = noCount(a[argIndex]);
        return orig.apply(this, a);
      };
      wrapped.__cnNoCount = true;
      p[method] = wrapped;
    });
  }
  patchMsg('product-form', 'handleErrorMessage', 0);
  patchMsg('cart-items', 'updateLiveRegions', 1);
  patchMsg('cart-drawer-items', 'updateLiveRegions', 1);

  /* ---- Which products the page has already shown ----
     The homepage stacks a hero, New arrivals, a size row and Recently viewed, all drawing on the
     same new-arrivals collection, so without this the same piece appears three times. Sections are
     walked in the order they sit on the page: whatever came first keeps the product. */
  var seen = {};
  function handleOf(a) {
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function markSeen(h) { if (h) seen[h] = true; }

  function dedupeList(ul) {
    var limit = parseInt(ul.getAttribute('data-cn-limit'), 10) || 8;
    var kept = 0;
    Array.prototype.slice.call(ul.querySelectorAll(':scope > li')).forEach(function (li) {
      var h = handleOf(li.querySelector('a[href*="/products/"]'));
      if (!h || seen[h] || kept >= limit) { li.remove(); return; }
      seen[h] = true;
      li.classList.remove('cn-spare');
      kept++;
    });
  }
  function dedupeHome() {
    document.querySelectorAll('[data-cn-hero-track] a[href*="/products/"]').forEach(function (a) {
      markSeen(handleOf(a));
    });
    document.querySelectorAll('ul[data-cn-dedupe]').forEach(function (ul) {
      /* v1.3: a size row still waiting for its tiles is trimmed when they arrive (sizeRowFill) */
      if (ul.closest('[data-cn-sizerow-wait]')) return;
      dedupeList(ul);
    });
  }

  /* ---- Recently viewed ----
     Rendered server-side per handle (?view=cnrv) so tiles keep the hover quick add and grouping.
     The fetches wait until the row is near the viewport: it sits below the fold, and firing a
     request per handle on load competed with the page itself. */
  function baseTitle(t) {
    t = String(t || '').replace(/\s+/g, ' ').trim();
    var i = t.lastIndexOf(' • ');
    return (i > 0 ? t.slice(0, i) : t).trim().toLowerCase();
  }
  function renderRecent() {
    var box = document.querySelector('[data-cn-rv]');
    if (!box || box.dataset.cnRvDone) return;
    box.dataset.cnRvDone = '1';
    var list = box.querySelector('[data-cn-rv-list]');
    var current = box.getAttribute('data-current');
    var currentTitle = baseTitle(box.getAttribute('data-current-title'));
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('cnRecentlyViewed') || '[]'); } catch (e) {}
    handles = handles.filter(function (h) {
      return h && typeof h === 'string' && h !== current && !seen[h];
    }).slice(0, 10);
    if (!handles.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=cnrv')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var byTitle = {};
      if (currentTitle) byTitle[currentTitle] = true;
      var frag = document.createDocumentFragment();
      var count = 0;
      htmls.forEach(function (html) {
        if (!html || count >= 6) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var li = tpl.content.querySelector('li.grid__item');
        if (!li) return;
        var h = handleOf(li.querySelector('a[href*="/products/"]'));
        if (h && seen[h]) return;
        var head = li.querySelector('.card__heading');
        var key = baseTitle(head ? head.textContent : li.textContent);
        if (!key || byTitle[key]) return;
        byTitle[key] = true;
        markSeen(h);
        li.classList.remove('scroll-trigger', 'animate--slide-in');
        frag.appendChild(li);
        count++;
      });
      if (!count) return;
      list.innerHTML = '';
      list.appendChild(frag);
      box.hidden = false;
    });
  }
  function whenNear(el, fn) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      fn();
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  /* ---- "New in your size" row (homepage) ----
     Uses the size the shopper picked on a collection page or, failing that (v94), the size they
     have been browsing (cnSizeGuess, kept by sections/cn-recently-viewed), with the same
     waist/letter equivalence as the collection filter. The row renders hidden with a wide set of
     tiles; the ones in their size survive, de-duplication trims the rest, and the row only
     appears when at least two are left. */
  function mySize() {
    var s = '', src = '';
    try {
      s = localStorage.getItem('cnMySize') || '';
      if (s) src = 'picked';
      else { s = localStorage.getItem('cnSizeGuess') || ''; if (s) src = 'browsed'; }
    } catch (e) {}
    return { size: s, src: src };
  }
  function sizeRowFilter() {
    var row = document.querySelector('[data-cn-sizerow]');
    if (!row) return null;
    var my = mySize(), size = my.size;
    if (!size) { row.remove(); return null; }
    var why = row.querySelector('[data-cn-sizerow-why]');
    if (why) why.textContent = my.src === 'picked' ? 'The size you picked' : "From what you've been browsing";
    var list = row.querySelector('[data-cn-sizerow-list]');
    if (!list) return null;
    Array.prototype.slice.call(list.querySelectorAll(':scope > li')).forEach(function (li) {
      var attr = li.getAttribute('data-cn-sizes');
      if (attr === null || !sizeHit(attr, size)) li.remove();
    });
    var label = row.querySelector('[data-cn-sizerow-size]');
    if (label) label.textContent = size.toUpperCase();
    return row;
  }
  function sizeRowShow(row) {
    if (!row) return;
    /* v90: grouped tiles left in the row open the shopper's size (after de-duplication, which
       compares each tile's usual destination) */
    var size = mySize().size;
    if (size) row.querySelectorAll('[data-cn-sizerow-list] > li[data-cn-dest]').forEach(function (li) { cnPointTile(li, size); });
    var left = row.querySelectorAll('[data-cn-sizerow-list] > li').length;
    if (left >= 2) row.hidden = false; else row.remove();
  }
  /* v1.3: run by sections/cn-home-size once its tiles have arrived, after the rest of the
     homepage has been de-duplicated, so the row still only shows pieces nothing above it showed */
  function sizeRowFill() {
    var row = sizeRowFilter();
    if (!row) return;
    var ul = row.querySelector('ul[data-cn-dedupe]');
    if (ul) dedupeList(ul);
    sizeRowShow(row);
  }

  /* ---- Quick add sits on the price line (v60) ----
     On hover the Add to Cart bar takes the place of the price and size lines, under the product
     name. Where that line falls depends on the photo's height and how many lines the name wraps
     to, so it is measured on the card being hovered, just before the bar fades in, and handed to
     the CSS as --cn-qa-top. Measuring on hover means cards added later by infinite scroll and
     layout changes after a resize are always right, with nothing to keep in sync. */
  function anchorQuickAdd(li) {
    if (!li || !li.querySelector('.cn-qa')) return;
    var info = li.querySelector('.card > .card__content .card__information');
    var price = info && info.querySelector('.price');
    if (!price) return;
    var top = price.getBoundingClientRect().top - li.getBoundingClientRect().top;
    if (top > 0) li.style.setProperty('--cn-qa-top', Math.round(top - 2) + 'px');
  }
  document.addEventListener('pointerover', function (e) {
    var li = e.target.closest && e.target.closest('.cn-qa-item');
    if (li && !li.contains(e.relatedTarget)) anchorQuickAdd(li);
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var li = e.target.closest && e.target.closest('.cn-qa-item');
    if (li) anchorQuickAdd(li);
  });

  /* ---- Header height (for sticky mobile filter bar) ---- */
  function headerVar() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--cn-header-h', h.offsetHeight + 'px');
  }

  function init() {
    refreshShip();
    var waiting = document.querySelector('[data-cn-sizerow-wait]');
    var row = waiting ? null : sizeRowFilter();
    dedupeHome();
    sizeRowShow(row);
    window.cnSizeRowFill = sizeRowFill;
    whenNear(document.querySelector('[data-cn-rv]'), renderRecent);
    headerVar();
    window.addEventListener('resize', headerVar);
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshShip, 50); });
      }
    } catch (e) {}
    document.addEventListener('cart:updated', refreshShip);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var t;
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) { return !(m.target.closest && m.target.closest('[data-cn-ship]')); });
        if (!relevant) return;
        clearTimeout(t); t = setTimeout(refreshShip, 150);
      })
        .observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
